import IntercomSDK, {
  shutdown as shutdownIntercom,
  update as updateIntercom,
} from '@intercom/messenger-js-sdk';
import { UserArgs } from '@intercom/messenger-js-sdk/types';

import constants from '../../constants.json';
import { getIntercomJwt } from '../intercom.service';

export const useProductionIntercomAppId =
  constants.GIT_BRANCH === 'master' && process.env.ENVIRONMENT === 'production';
const intercomAppId = useProductionIntercomAppId ? 'uhituceq' : 'vyptbpab';

const initialiseIntercom = async (disable = false): Promise<void> => {
  if (disable) {
    return;
  }
  try {
    const token = await getIntercomJwt();

    IntercomSDK({
      app_id: intercomAppId,
      intercom_user_jwt: token,
    });
  } catch (error) {
    console.error('Error initialising Intercom', error);
  }
};

export const useIntercom = () => {
  const update = (updates: UserArgs) => {
    updateIntercom(updates);
  };

  const shutdown = () => {
    shutdownIntercom();
  };

  return {
    update,
    shutdown,
  };
};

export const Intercom = {
  initialize: initialiseIntercom,
};
